import React, { useEffect, useState } from 'react'
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import Axios from "axios";
// material ui
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import Drawer from '@material-ui/core/Drawer';
import Icon from '@mdi/react'
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

// import Icon from '@mdi/react'
import { mdiFacebook, mdiTwitter } from '@mdi/js';
// components
import WidgetBar from '../../../../builder/components/WidgetBar.js'
import Theme from '../../Theme.js';
// helpers
import { getMessage } from '../helpers.js'
// helpers
import { translate } from '../translations.js'


const useStyles = makeStyles({
  card: {
    boxShadow: Theme.cardBoxShadow,
    marginBottom: '28px',
    position: 'relative',
  },
  actions: {
    padding: '24px 0',
    justifyContent: 'space-between',
    '&:before': {
      content: '""',
      display: 'block',
    },
    '&:after': {
      content: '""',
      display: 'block',
    },
  }
});

export default function Photo(props) {
  const { context, screen } = props;
  const [showWidgetBar, setShowWidgetBar] = useState(false)
  const classes = useStyles();
  const photos = context["photos"];
  const tweetText = context["tweet_text"]
  var order;
  (screen == 'desktop') ? (order = context.desktop_order) : (order = context.mobile_order);
  const componentClasses = clsx({
    [classes.card] : true,
    "cardMobile" : screen == 'mobile' ? true : false,
  })

  if (window.mode == 'live') {
    var language = window.language;
  } else {
    var language = useSelector(state => state.language);
  }

  const handleWidgetHover = (e) => {
    if (e.type == 'mouseenter') {
      setShowWidgetBar(true);
    } else if (e.type == 'mouseleave') {
      setShowWidgetBar(false);
    }
  }
  
  return (
    <Card id="Photo" style={{ order: order }} className={componentClasses + ' photo-widget'}
      onMouseEnter={window.mode == 'builder' ? handleWidgetHover : null} onMouseLeave={window.mode == 'builder' ? handleWidgetHover : null}
    >
      <PhotoBlock language={language} Photos={photos} tweetText={tweetText} sharing={context.sharing} />
      <PhotoComment comment={context.comment} language={language} sharing={context.sharing} />
      {(context.sharing.show && (context.sharing.show_facebook || context.sharing.show_twitter)) &&
        <CardActions className={classes.actions} >
          {context.sharing.show_facebook &&
            <FacebookShareButton buttonId="fbSharePhotoBlock" language={language} sharing={context.sharing} />
          }
          {context.sharing.show_twitter &&
            <TweetButton buttonId="tweetPhotoBlock" text={tweetText} language={language} sharing={context.sharing} />
          }
        </CardActions>
      }
      {window.mode == 'builder' && showWidgetBar &&
        <WidgetBar context={context} />
      }
    </Card>
  )
}

const photoBlockStyles = makeStyles({
  photoBlock: {
    display: 'flex',
    margin: 0,
    padding: 0,
    listStyle: 'none',
    '& .photo-list__item': {
      position: 'relative',
      '&.multiple-photos': {
        cursor: 'pointer',
        '&:hover': {
          opacity: '.9',
        },
        '& > img': {
          position: 'absolute',
        },
        '&::after': {
          content: '""',
          display: 'block',
          paddingBottom: '100%',
        },
      },
      '&.top': {
        '& > img': {
          padding: '0 1px',
        },
        '&:first-child > img': {
          paddingLeft: 0,
        },
        '&:last-child > img': {
          paddingRight: 0,
        },
      },
      '&.bottom': {
        '& > img': {
          padding: '2px 1px 0',
        },
        '&:first-child > img': {
          paddingLeft: 0,
        },
        '&:last-child > img': {
          paddingRight: 0,
        },
      },
    },
    '& .photo-list__item__img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    '& .overlay': {
      position: 'absolute',
      top: '2px',
      bottom: '0px',
      left: '1px',
      right: '0px',
      background: 'rgba(0,0,0,.5)',
      color: '#f1f1f1',
      transition: '.5s ease',
      opacity: '1',
      color: 'white',
      fontSize: '28px',
      fontWeight: 'bolder',
      textAlign: 'center',
      '& > span': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    },
  },
  drawerHeader: {
    backgroundColor: Theme.bgColorDark,
    padding: '1rem',
    position: 'relative',
    textAlign: 'center',
    '& > button': {
      left: '0',
      padding: '.5rem',
      position: 'absolute',
      margin: '.5rem',
      top: '0',
    },
    '& > div': {
      fontFamily: Theme.typography.fontFamily,
      fontWeight: '500',
      lineHeight: '1.5rem',
    }
  },
  drawerPhotoContainer: {
    backgroundColor: Theme.bgColorMd,
    boxShadow: Theme.cardBoxShadow,
  },
  photoDrawer: {
    '& .MuiDrawer-paper': {
      width: '400px',
      maxWidth: '100%',
      backgroundColor: '#e9ebee !important',
      paddingBottom: '40px',
    },
    '& .drawer': {
      '&__header': {
        textAlign: 'center',
        padding: '1rem',
      },
      '&__photo-container': {
        margin: '.5rem .5rem 0 .5rem',
        overflow: 'visible !important',
        '& > img': {
          padding: '.5rem',
          width: '100%',
        },
        '&__actions': {
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '.75rem',
          '&:before, &:after': {
            'content': '""',
            'display': 'block',
          },
        },
      },
    },
  },
});

function PhotoBlock(props) {
  const { language, Photos, tweetText, sharing } = props
  const [isPhotoDrawerOpen, setIsPhotoDrawerOpen] = React.useState(false)
  const photoCount = Photos.length;

  const topRowLength = (photoCount <= 3) ? photoCount : 2;
  const bottomRowLength = (photoCount <= 3) ? 0 : Math.min(photoCount - 2, 3);
  // styles
  const topRowImageWidth = { width: (100/topRowLength) + '%', };
  const bottomRowImageWidth = { width: (100/bottomRowLength) + '%', };
  const classes = photoBlockStyles();

  const togglePhotoDrawer = (open) => event => {
    if ((event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) || photoCount < 2) {
      return;
    }
    setIsPhotoDrawerOpen(open);
  };

  return (
    <React.Fragment>
      <ul className={classes.photoBlock}>
        {Photos.slice(0, topRowLength).map((photo, index) =>
          <li key={index} style={topRowImageWidth}
            className={clsx('photo-list__item', 'top', {['multiple-photos']: (photoCount > 1) })}
            onClick={togglePhotoDrawer(true)}
          >
            <img src={photo.url} className="photo-list__item__img" data-fb-photo-id={photo.fb_photo_id} 
              id={(index==0) ? "firstPhoto" : ""}
            />
          </li>
        )}
      </ul>
      {bottomRowLength > 0 &&
        <ul className={classes.photoBlock}>
          {Photos.slice(2, bottomRowLength + 2).map((photo, index) =>
            <li key={index} style={bottomRowImageWidth}
              className={clsx('photo-list__item', 'bottom', {['multiple-photos']: (photoCount > 1) })}
              onClick={togglePhotoDrawer(true)}
            >
              <img src={photo.url} className="photo-list__item__img" />
              {photoCount > 5 && index == 2 &&
                <div className="overlay">
                  <span>+{photoCount - 5}</span>
                </div>
              }
            </li>
          )}
        </ul>
      }
      
      <Drawer anchor="right" open={isPhotoDrawerOpen} onClose={togglePhotoDrawer(false)} className={classes.photoDrawer} >
        <div className={classes.drawerHeader} >
          <IconButton aria-label="close" onClick={togglePhotoDrawer(false)} >
            <CloseIcon />
          </IconButton>
          <div>{translate("Group Photos", language)}</div>
        </div>
        {Photos.map((photo, index) =>
          <Card key={index} className="drawer__photo-container" >
            <img src={photo.url} data-fb-photo-id={photo.fb_photo_id} />
            {(sharing.show && (sharing.show_facebook || sharing.show_twitter)) &&
              <Box className="drawer__photo-container__actions">
                {sharing.show_facebook && <FacebookShareButton language={language} sharing={sharing} />}
                {sharing.show_twitter && <TweetButton language={language} text={tweetText} sharing={sharing} />}
              </Box>
            }
          </Card>
        )}
      </Drawer>

    </React.Fragment>
  )
}

const buttonStyles = makeStyles({
  actionButton: {
    width: ({otherButton}) => otherButton ? '35%' : '50%',
    margin: 0,
    color: '#ffffff !important',
    '&.facebook': {
      background: '#3C5A99',
      '&:hover': {
        background: '#2e4474',
      },
    },
    '&.twitter': {
      background: '#1DA1F2',
      '&:hover': {
        background: '#0c85d0',
      },
    },
  },
  icon: {
    marginRight: '6px',
  },
  loadingState: {
    color: 'white',
    margin: '3px',
  },
});

function FacebookShareButton(props) {
  const otherButton = props.sharing.show_twitter;
  const classes = buttonStyles({otherButton});
  const actionBtnClasses = clsx({
    [classes.actionButton]: true,
    'photo-action-btn': true,
    'facebook': true,
    'twitter': false,
  })


  function facebookShare(e) {
    if (window.mode == "live") {
      var elementId = e.target.closest('.photo-action-btn').id;
      if (elementId === "fbSharePhotoBlock") {
        var sharedImg = document.getElementById("firstPhoto");
      } else {
        var sharedImg = e.target.closest(".drawer__photo-container").getElementsByTagName("img")[0];
      }
      // var photoSrc = sharedImg.getAttribute('src')
      FB.ui({
        method: 'share',
        href: window.location.href,
      }, function(response){});
    }
  }

  return (
    <Button onClick={facebookShare} variant="contained" size="small" id={props.buttonId} className={actionBtnClasses} >
      <Icon
          path={mdiFacebook}
          size={.75}
          color="white"
          className={classes.icon}
      />
      {translate("Share", props.language)}
    </Button>
  )
}

function TweetButton(props) {
  const [tweetLoading, setTweetLoading] = useState(false);
  const otherButton = props.sharing.show_facebook;
  const classes = buttonStyles({otherButton});
  const actionBtnClasses = clsx({
    [classes.actionButton]: true,
    'photo-action-btn': true,
    'facebook': false,
    'twitter': true,
  })

  function tweet(e) {
    if (window.mode == "live") {
      setTweetLoading(true)
      const windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes'
      const width = 550
      const height = 420
      const winWidth = screen.width
      const winHeight = screen.height
      const left = Math.round((winWidth / 2) - (width / 2))
      let top = 0
      if (winHeight > height) {
        top = Math.round((winHeight / 2) - (height / 2))
      }

      const url = new URL('https://twitter.com/intent/tweet')
  
      // set tweet text
      if (props.sharing.tweet[language]) {
        url.searchParams.append('text', props.sharing.tweet[language])
      }
  
      // set twitter handle
      const twitterHandle = props.sharing.twitter_handle.trim()
      if (twitterHandle) {
        url.searchParams.append('via', twitterHandle)
      }

      // set url
      url.searchParams.append('url', window.location.href)

      const tweetWindow = window.open("about:blank", "intent", windowOptions + ',width=' + width + ',height=' + height + ',left=' + left + ',top=' + top)
      tweetWindow.location.href = url.href
      setTweetLoading(false)
    }
  }

  return (
    <Button onClick={tweet} variant="contained" size="small" id={props.buttonId} className={actionBtnClasses} >
      { tweetLoading
        ? <CircularProgress size={16} className={classes.loadingState} />
        : <>
            <Icon
              path={mdiTwitter}
              size={.75}
              color="white"
              className={classes.icon}
            />
            {translate("Tweet", props.language)}
          </>
      }
    </Button>
  )
}



const photoCommentStyles = makeStyles({
  avatar: {
    height: '3.25rem',
    width: '3.25rem',
    boxShadow: Theme.avatarBoxShadow,
  },
  card: {
    marginBottom: '1.75rem',
    boxShadow: Theme.cardBoxShadow,
  },
  cardActions: {
    // justifyContent: 'space-evenly',
    padding: '.5rem 1rem 1.5rem',
    justifyContent: 'space-between',
    '&:before': {
      content: '""',
      display: 'block',
    },
    '&:after': {
      content: '""',
      display: 'block',
    },
  },
  cardActionsButton: {
    width: '100%',
    maxWidth: '250px',
  },
  cardComment: {
    alignItems: 'start',
    paddingBottom: ({showingSharing}) => showingSharing ? '0' : '16px',
  },
  cardCommentAvatar: {
    height: '2.5rem',
    width: '2.5rem',
    boxShadow: Theme.avatarBoxShadow,
  },
  cardCommentText: {
    display: 'flex',
    flexDirection: 'column',
    padding: '.5rem .625rem',
    background: Theme.bgColorMd,
    borderRadius: '18px',
    maxWidth: '400px',
    whiteSpace: 'pre-line',
    '& span': {
      marginRight: '3px',
      fontWeight: '500',
      fontSize: '.75rem',
      '&:last-child': {
        marginRight: '0px',
      }
    }
  },
  cardHeaderTitle: {
    fontSize: '.65rem',
    textTransform: 'uppercase',
  },
  cardHeaderSubTitle: {
    fontSize: '1rem',
    whiteSpace: 'pre-line',
  },
  commentCardHeaderContent: {
    flex: '0 1 auto',
  },
});

function PhotoComment(props) {
  // const [comment, setComment] = useState(props.comment);
  const { comment, language, sharing } = props;
  const showingSharing = sharing.show && (sharing.show_facebook || sharing.show_twitter);
  const classes = photoCommentStyles({showingSharing});
  var commentText;
  if (window.mode == 'live') {
    commentText = comment.text;
  } else {
    var activeRoom = useSelector(state => state.activeRoom);
    var didEscape = useSelector(state => state.didEscape);
    var groupType = useSelector(state => state.groupType);
    var roomMessaging = useSelector(state => state.roomMessaging);
    commentText = getMessage("photo_comment", didEscape, activeRoom, groupType, roomMessaging, language)
  }


  return (
    <>
    {comment.show && (
      <CardHeader
        classes={{
          content: classes.commentCardHeaderContent,
        }}
        className={classes.cardComment}
        avatar={
          <Avatar src={comment.author_image} className={classes.cardCommentAvatar}>
            {!comment.author_image &&
              comment.author_name.charAt(0)
            }
          </Avatar>
        }
        subheader={
          <div className={classes.cardCommentText}>
            {comment.show_author && (
              <div>
              {(comment.author_final == "guide") && comment.guide_title &&
                <Typography variant="body2" color="textPrimary" component="span">
                  {comment.guide_title[language] || comment.guide_title['en']}
                </Typography>
              }
              <Typography variant="body2" color="textPrimary" component="span">
                {comment.author_name}
              </Typography>
              </div>
            )}
            {commentText}
          </div>
        }
      />
    )}
    </>
  )
}
